// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__vEM7w","insightsList":"newBusinessInsightsMenu_insightsList__Mta5q","active":"newBusinessInsightsMenu_active__2S7RD"};